export default __webpack_public_path__ + "images/5bea66df1197c84da70dff314f991526-bike-sa.svg";